document.addEventListener('alpine:init', () => {
    window.Alpine.data('eventOverview', (config) => ({
        allEvents: [],
        filteredEvents: [],
        showEvents: [],
        queryIds: config.queryIds ?? '',
        searchText: '',
        chosenCategories: [],
        chosenTypes: [],
        chosenLevels: [],
        freeEvent: false,
        allCategories: JSON.parse(JSON.stringify(config.allCategories)),
        allTypes: JSON.parse(JSON.stringify(config.allTypes)),
        allLevels: JSON.parse(JSON.stringify(config.allLevels)),
        isVerticalCard: config.isVerticalCard,
        imagePosition: config.imagePosition ?? 'top',
        isColumnGrid: config.isColumnGrid ?? false,
        limit: config.limit ?? 10,
        load: config.load ?? false,
        loading: true,
        page: 1,
        pages: 0,
        allItemsLoaded: false,
        filterActivated: false,
        category: '',
        changedFilterValues: {
            ['@text-search-changed.window'](event) {
                this.searchText = event.detail.value.toLowerCase();
                this.filterElements();
            },
            ['@multi-select-on-change.window'](event) {
                switch (event.detail.fieldName) {
                    case 'choose_category':
                        if (Object.keys(event.detail.values).length === 0) {
                            this.chosenCategories = this.allCategories;
                        } else {
                            this.chosenCategories = event.detail.values;
                        }
                        break;
                    case 'choose_level':
                        if (Object.keys(event.detail.values).length === 0) {
                            this.chosenLevels = this.allLevels;
                        } else {
                            this.chosenLevels = event.detail.values;
                        }
                        break;
                    case 'choose_type':
                        if (Object.keys(event.detail.values).length === 0) {
                            this.chosenTypes = this.allTypes;
                        } else {
                            this.chosenTypes = event.detail.values;
                        }
                        break;
                    default:
                        console.error('Unknown field name');
                }
                this.filterElements();
            },
            ['@lightswitch-changed.window'](event) {
                this.freeEvent = event.detail.value === 'checked';
                this.filterElements();
            },
        },
        init() {
            // Initial load of the blog-articles if by default "load" is true
            if(this.load) {
                this.loadEvents();
            }

            // Check if "loaded" is true to execute the fetch command
            this.$watch('load', (value) => {
                if (value) {
                    this.loadEvents();
                }
            });
        },
        loadEvents() {
            window.getRequest({
                params: {
                    action: '/bx-module/events/academy-events',
                    queryIds: this.queryIds,
                    isVerticalCard: this.isVerticalCard,
                    imagePosition: this.imagePosition,
                },
            }).then((response) => {
                this.allEvents = JSON.parse(JSON.stringify(response.data.events));
                this.filteredEvents = this.allEvents;
                this.pages = this.allEvents.length / this.limit;
                this.chosenCategories = this.allCategories;
                this.chosenTypes = this.allTypes;
                this.chosenLevels = this.allLevels;
                if (this.filterActivated) {
                    this.filterElements();
                } else {
                    this.showMore();
                }
                this.loading = false;
            });
        },
        filterElements() {

            // Reset variables
            this.setDefaultValues();

            this.filteredEvents = this.allEvents
                // search for text
                .filter((item) => {
                    return (item.title.toLowerCase().indexOf(this.searchText) > -1 || item.event_short_description.toLowerCase().indexOf(this.searchText) > -1) || this.searchText === '';
                })
                // filter free events
                .filter((item) => {
                    if (!this.freeEvent) {
                        return item;
                    }
                    if (this.freeEvent && item.free) {
                        return item;
                    }
                })
                // filter categories
                .filter((item) => {
                    if(Object.keys(this.chosenCategories).includes(item.category)) {
                        return item;
                    }
                })
                // filter levels
                .filter((item) => {
                    if(Object.keys(this.chosenLevels).includes(item.level)) {
                        return item;
                    }
                });

            this.showMore();
        },
        showMore() {
            if (!this.allItemsLoaded) {
                const start = this.limit * (this.page -1);
                const stop = this.limit * this.page;
                this.showEvents = this.showEvents.concat(this.filteredEvents.slice(start, stop));
            }
            // Increase page number if there are more events to show, otherwise
            // set allItemsLoaded to "true" which hide the "Show more" button
            if (this.page < this.filteredEvents.length / this.limit) {
                this.page++;
                this.allItemsLoaded = false;
            } else {
                this.allItemsLoaded = true;
            }

        },
        setDefaultValues() {
            this.page = 1;
            this.showEvents = [];
            this.allItemsLoaded = false;
        },
        resetFilters() {
            window.dispatchEvent(new CustomEvent('reset-text-search', {
                detail: {
                    value: '',
                }
            }));

            window.dispatchEvent(new CustomEvent('reset-categories', {
                detail: {
                    fieldName: 'choose_category',
                    values: {},
                    value: {},
                    placeholder: '',
                }
            }));

            window.dispatchEvent(new CustomEvent('reset-types', {
                detail: {
                    fieldName: 'choose_type',
                    values: {},
                    value: {},
                    placeholder: '',
                }
            }));

            window.dispatchEvent(new CustomEvent('reset-levels', {
                detail: {
                    fieldName: 'choose_level',
                    values: {},
                    value: {},
                    placeholder: '',
                }
            }));

            window.dispatchEvent(new CustomEvent('reset-event-free', {
                detail: {
                    fieldName: 'event_free',
                    values: {},
                    value: {},
                    placeholder: '',
                }
            }));

            this.searchText = '';
            this.chosenCategories = this.allCategories;
            this.chosenLevels = this.allLevels;
            this.chosenTypes = this.allTypes;
            this.freeEvent = false;
            this.filterElements();
        },
        compareObjects(filter, item) {
            for (let key in filter) {
                if (item.hasOwnProperty(key)) {
                    return true;
                }
            }
        }
    }));
});
